import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MultiSelect } from "react-multi-select-component";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { contactJson } from "../modal/contactModal";
import { activityJson, activityJson2 } from "../modal/activityModal";
import { contactDetails, insertContact_Fn } from "../actions/contactActions";
import Year from "../components/Year";
import {
  clr,
  ContactCreateValidator1_Nepal,
  CountryListJson,
  gridClr,
  thTdStyle3,
} from "../Model/contactModel";
import { useParams } from "react-router-dom";

import {
  sectionStyle,
  tableStyle,
  thTdStyle,
  thTdStyle1,
  thTdStyle2,
} from "../Model/contactModel";
import { sourcesHeard } from "../Model/newformModel";
import {
  activityCreateDetails,
  activityDetails,
  activityUpdateDetails,
} from "../actions/activityActions";
import { getintake } from "../actions/intakeActions";
import { getFieldOfStudy } from "../actions/fieldofStudyActions";
import { All_University_Logo } from "../modal/University";

function BookMyShow(props) {
  const dispatch = useDispatch();
  const [details, setDetails] = useState(contactJson);
  const [FormError, setFormError] = useState("");
  // const [id2, setid2] = useState(0);
  const [activity, setActivity] = useState(activityJson2);
  const [recid, setrecid] = useState();

  const [Country, setCountry] = useState([]);
  const [Country2, setCountry2] = useState([]);
  const [heardFrom, setHearForm] = useState([]);
  const [Others, setOthers] = useState("");
  const { eventId } = useParams();
  // Three section for three parts:

  const [sec2, setSec2] = useState(true);
  const [sec3, setSec3] = useState(false);
  const [sec4, setSec4] = useState(false);
  const [sec5, setSec5] = useState(false);
  const [step, setStep] = useState(1);
  //   const { countries, loadingCntr, errorCntr } = useSelector(
  //     (state) => state.countryList
  //   );

  //   Prefferd intake
  const intakeList = useSelector((state) => state.intakeList);
  const { intakes } = intakeList;

  useEffect(() => {
    if (!intakes) {
      dispatch(getintake());
    }
  }, [intakes]);

  const fieldsList = useSelector((state) => state.fieldsList);
  const { fields } = fieldsList;

  useEffect(() => {
    if (!fields) {
      dispatch(getFieldOfStudy());
    }
  }, [fields]);

  // console.log(details);

  const {
    contact: ContactId3,
    loading: loadingAcc,
    error: errorAcc,
    success: successAcc,
  } = useSelector((s) => s.activityCreateDetailsReducer);
  const {
    contact: ContactId,
    success: successCreate,
    loading: loadingCreate,
    error: errorCreate,
  } = useSelector((state) => state.createContact);

  const {
    loading: loadingAc,
    activityDet,
    eventActivity,
    error: errorAc,
  } = useSelector((s) => s.activityDetailsReducer);
  const {
    contact: ContactIdC,
    loading: loadingAcu,
    success: successAcu,
    error: errorAcu,
  } = useSelector((s) => s.activityUpdateDetailsReducer);
  const {
    contactDet,
    loading: loadingContactDet,
    error: errorContactDet,
  } = useSelector((s) => s.contactDetailsReducer);
  const {
    contact: ContactId2,
    success: successCreate2,
    loading: loadingCreate2,
    error: errorCreate2,
  } = useSelector((state) => state.createContact2);

  const handleClear = (e) => {
    e.preventDefault();
    setDetails({ ...contactJson });
    setrecid("");
  };

  const handleChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value });
  };

  const handleStepNext = () => {
    if (step < 11) {
      setStep(step + 1);
    }
  };

  const handleStepPrev = () => {
    if (step !== 1) {
      setStep(step - 1);
    }
  };
  const handleFormChange = (e) => {
    setActivity({ ...activity, [e.target.name]: e.target.value });
  };

  const save2ndStep = (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    setFormError("");

    var activityHtml = `<div className="container">
    <div className="row">
        <div className="col-md-12">
            <div className="table table-responsive">
                <table className="table-striped">
                    <tr>
                        <td>Branch: $$Branch</td>
                        <td>Medium:Form <br/> <br/> Event: ${eventId}</td>
                    </tr>
                    <tr>
                        <td>Email Address: <br/> ${details.Email_Address}</td>
                        <td>Phone No: <br/>${details.Phone_No}</td>
                    </tr>
                    <tr>
                        <td>First Name: <br/> ${details.First_Name}</td>
                        <td>Last Name: <br/>${details.Last_Name}</td>
                    </tr>
                    <tr>
                        <td>Gender: <br/> ${
                          details?.Gender.toString() == "1"
                            ? "Male"
                            : details?.Gender.toString() == "2"
                            ? "Female"
                            : "Other"
                        }</td>
                        <td>Date of Birth: <br/>${
                          details.Date_Of_Birth ? details.Date_Of_Birth : ""
                        }</td>
                    </tr>
                    <tr>
                        <td>Marital Status: <br/> ${
                          details.Marital_Status == "1"
                            ? "Unmarried"
                            : details.Marital_Status == "2"
                            ? "Married"
                            : "Other"
                        }</td>
                        <td>Alternate Phone: <br/>${details.Phone_No1}</td>
                    </tr>
                    <tr>
                        <td>City: <br/> ${details.City}</td>
                        <td>State: <br/>${details.State}</td>
                    </tr>
                     <tr>
                        <td>Platform: <br/> Book My Show</td>
                        
                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>`;
    // var activityHtml = `<div >
    // <div
    //  style="
    //      background: #fff;
    //      color: #000;
    //      border-radius: 5px;
    //      box-shadow: 0 0 10px rgba(0,0,0,0.2);
    //    ">
    //    <h2 style="
    //        padding: 10px 20px;
    //        background-color: #211762;
    //        color: #fff;
    //        text-align: center;
    //      ">
    //      Student Information<br/>
    //      ${details?.Contact_Id} - ${details?.First_Name}
    //    </h2>

    //    <div>

    //    <div   style=${
    //      activity.board || activity.passingYear12 || activity.stream
    //        ? "margin-top:10px"
    //        : "display:none;margin-top:10px"
    //    } >
    //      <h4 style="${sectionStyle}">Year 12th</h4>
    //      <table style="${tableStyle}"}>
    //        <tbody>
    //          <tr>

    //            <td style="${thTdStyle3}">${
    // activity.board || activity.passingYear12 || activity.stream
    // ? `${activity.board || "N/A"} - ${activity.passingYear12 || "N/A"} - ${
    //     activity.stream || "N/A"
    //   } - ${activity.percentage12 || "N/A"}`
    // : ""
    // }</td>
    //          </tr>

    //        </tbody>
    //      </table>
    //    </div>

    //    <div   style=${
    //      activity.universityUG || activity.passingYearUG
    //        ? "margin-top:2px"
    //        : "display:none"
    //    }>
    //      <h4 style="${sectionStyle}">Bachelor's Details</h4>
    //      <table style="${tableStyle}"}>
    //        <tbody>
    //          <tr >

    //            <td style="${thTdStyle3}" >${
    // activity.universityUG || activity.passingYearUG
    // ? `${activity.universityUG || "N/A"} - ${
    //     activity.passingYearUG || "N/A"
    //   } - ${activity.subjectUG || "N/A"} - ${
    //     activity.percentageUG || "N/A"
    //   }`
    // : ""
    // }</td>
    //          </tr>

    //        </tbody>
    //      </table>
    //    </div>

    //    <div style=${
    //      activity.universityPG || activity.passingYearPG
    //        ? "margin-top:2px"
    //        : "display:none"
    //    }>
    //      <h4 style="${sectionStyle}">Master's Details</h4>
    //      <table style="${tableStyle}"}>
    //        <tbody>
    //          <tr>
    //            <td style="${thTdStyle3}" >${
    // activity.universityPG || activity.passingYearPG
    // ? `${activity.universityPG || "N/A"} - ${
    //     activity.passingYearPG || "N/A"
    //   } - ${activity.subjectPG || "N/A"} - ${
    //     activity.percentagePG || "N/A"
    //   }`
    // : ""
    // }</td>

    //          </tr>

    //        </tbody>
    //      </table>
    //    </div>

    //    <div>
    //      <h4 style="${sectionStyle}">Preferences</h4>
    //      <table style="${tableStyle}"}>
    //        <tbody>
    //          <tr  style=${
    //            activity.preferredDegree || activity.preferredDegreeOther
    //              ? "margin-top:0px"
    //              : "display:none"
    //          }>
    //            <td style="${thTdStyle1}">Preferred Degree:</td>
    //            <td style="${thTdStyle}">${
    // activity.preferredDegree
    // ? activity.preferredDegree
    // : activity.preferredDegreeOther
    // ? activity.preferredDegreeOther
    // : ""
    // }</td>
    //          </tr>
    //          <tr   style=${
    //            Country?.length ? "margin-top:0px" : "display:none"
    //          }>
    //            <td style="${thTdStyle1}">Preferred Country:</td>
    //            <td style="${thTdStyle}">${
    // Country?.length ? Country?.join(",") : ""
    // }</td>
    //          </tr>
    //          <tr style=${
    //            activity.preferredField ? "margin-top:0px" : "display:none"
    //          } >
    //            <td style="${thTdStyle1}">Preferred Field of Study:</td>
    //            <td style="${thTdStyle}">${
    // activity.preferredField || ""
    // }</td>
    //          </tr>
    //          <tr  style=${
    //            activity.preferredIntake ? "margin-top:0px" : "display:none"
    //          }>
    //            <td style="${thTdStyle1}">Preferred Intake:</td>
    //            <td style="${thTdStyle}">${
    // activity.preferredIntake || ""
    // }</td>
    //          </tr>
    //        </tbody>
    //      </table>
    //    </div>

    //    <div>
    //      <h4 style="${sectionStyle}">Additional Information</h4>
    //      <table style="${tableStyle}"}>
    //        <tbody>
    //          <tr  style=${
    //            activity.workExperience ? "margin-top:0px" : "display:none"
    //          }>
    //            <td style="${thTdStyle1}">Work Experience:</td>
    //            <td style="${thTdStyle}">${
    // activity.workExperience || ""
    // }</td>
    //          </tr>
    //          <tr  style=${
    //            activity.givenTest ? "margin-top:0px" : "display:none"
    //          }>
    //            <td style="${thTdStyle1}">Given Test:</td>
    //            <td style="${thTdStyle}">${activity.givenTest || ""}</td>
    //          </tr>
    //          <tr  style=${
    //            activity.testName ? "margin-top:0px" : "display:none"
    //          }>
    //            <td style="${thTdStyle1}">Test Name:</td>
    //            <td style="${thTdStyle}">${activity.testName || ""}</td>
    //          </tr>
    //          <tr  style=${
    //            heardFrom?.length ? "margin-top:0px" : "display:none"
    //          }>
    //            <td style="${thTdStyle1}">Heard From:</td>
    //            <td style="${thTdStyle}">${
    // heardFrom?.length ? heardFrom?.join(",") : ""
    // }</td>
    //          </tr>
    //          <tr  style=${
    //            activity.otherComments ? "margin-top:0px" : "display:none"
    //          }>
    //            <td style="${thTdStyle1}">Other Comments:</td>
    //            <td style="${thTdStyle}">${activity.otherComments || ""}</td>
    //          </tr>
    //        </tbody>
    //      </table>
    //    </div>

    //    <div id="personal_info" style="display:none;margin-top:1.2px">
    //      <h4 style="${sectionStyle}">Personal Details</h4>
    //      <table style="${tableStyle}">
    //        <tbody>
    //          <tr>
    //            <td style="${thTdStyle2}">
    //              Branch: <span style="${clr}"> $$Branch</span>
    //            </td>
    //            <td style="${thTdStyle2}">
    //              Event: <span style="${clr}">${eventId || ""} </span>
    //            </td>
    //          </tr>
    //          <tr>
    //            <td style="${thTdStyle2}">
    //              Phone: <span style="${clr}">${
    // details.Phone_No || ""
    // } </span>
    //            </td>
    //            <td style="${thTdStyle2}">

    //              Email Address:<span style="${clr}">${
    // details.Email_Address || ""
    // } </span>
    //            </td>
    //          </tr>

    //          <tr>
    //            <td style="${thTdStyle2}">

    //              First Name:<span style="${clr}"> ${
    // details.First_Name || ""
    // }</span>
    //            </td>
    //            <td style="${thTdStyle2}">
    //              Last Name: <span style="${clr}">${
    // details.Last_Name || ""
    // } </span>
    //            </td>
    //          </tr>

    //          <tr>
    //            <td style="${thTdStyle2}">
    //              Phone No:<span style="${clr}">${
    // details?.Gender.toString() == "1"
    // ? "Male"
    // : details?.Gender.toString() == "2"
    // ? "Female"
    // : "Other" || ""
    // } </span>
    //            </td>
    //            <td style="${thTdStyle2}">

    //              Date of Birth: <span style="${clr}"> ${
    // details.Date_Of_Birth || ""
    // }</span>
    //            </td>
    //          </tr>

    //          <tr>
    //            <td style="${thTdStyle2}">
    //              Marital Status:
    //              <span style="${clr}"> ${
    // details.Marital_Status === "1"
    // ? "Unmarried"
    // : details.Marital_Status === "2"
    // ? "Married"
    // : "Other" || ""
    // }</span>
    //            </td>
    //            <td style="${thTdStyle2}">
    //              Alternate Phone:
    //              <span style="${clr}"> ${details.Phone_No1 || ""}</span>
    //            </td>
    //          </tr>

    //          <tr>
    //            <td style="${thTdStyle2}">
    //              City:<span style="${clr}"> ${details.City || ""}</span>
    //            </td>
    //            <td style="${thTdStyle2}">
    //              State:<span style="${clr}"> ${details.State || ""}</span>
    //            </td>
    //          </tr>
    //        </tbody>
    //      </table>
    //    </div>

    //  </div>
    // </div>`;

    let Validator = ContactCreateValidator1_Nepal({ ...details });

    if (Validator === "success") {
      var dt;
      if (eventId === "") {
        dt = {
          ...details,
          Activity: `Student Form Filled`,
          Activity_Des: activityHtml,
        };
      } else {
        dt = {
          ...details,
          Activity: `EventTaggedActivity${eventId}`,
          Activity_Des: activityHtml,
        };
      }

      dispatch(
        insertContact_Fn({ ...dt, link: window.location.href, Platform: "BMS" })
      );

      //   setSec2(false);
      //   setSec3(false);
      //   setSec4(true);
    } else {
      setFormError(Validator);
    }
    // setSec1(false);
  };

  const save3rdStep = (e) => {
    e.preventDefault();

    e.preventDefault();
    let validator = "success";
    setFormError("");

    var activityHtml = `<div >
        <div
         style="
             background: #fff; 
             color: #000; 
             border-radius: 5px; 
             box-shadow: 0 0 10px rgba(0,0,0,0.2);
           ">
          <h4 style="
               padding: 10px 20px; 
               background-color: #211762; 
               color: #fff; 
               text-align: center;
               display:flex;
               align-items:center;
               justify-content:center;
             ">
            <span> ${details?.Contact_Id}</span>  - <Span>${
      details?.First_Name ? details?.First_Name : details?.full_name
    }  </Span> <span>${
      activity?.contact_Type == "Yes"
        ? '- <i class="far fa-star" style="color:red"></i>'
        : ""
    }</span>
           </h4>
       
       
           <div>
       
       
           <div   style=${
             activity?.board || activity.passingYear12 || activity.stream
               ? "margin-top:10px"
               : "display:none;margin-top:10px"
           } >
             <h4 style="${sectionStyle}">Year 12th</h4>
             <table style="${tableStyle}"}>
               <tbody>
                 <tr>
                 
                   <td style="${thTdStyle3}">${
      activity?.board || activity?.passingYear12 || activity?.stream
        ? `${activity.board || "N/A"} - ${activity.passingYear12 || "N/A"} - ${
            activity.stream || "N/A"
          } - ${activity.percentage12 || "N/A"}`
        : ""
    }</td>
                 </tr>
                
                 
                
               </tbody>
             </table>
           </div>
       
           <div   style=${
             activity?.universityUG || activity?.passingYearUG
               ? "margin-top:2px"
               : "display:none"
           }>
             <h4 style="${sectionStyle}">Bachelor's Details</h4>
             <table style="${tableStyle}"}>
               <tbody>
                 <tr >
                  
                   <td style="${thTdStyle3}" >${
      activity?.universityUG || activity?.passingYearUG
        ? `${activity.universityUG || "N/A"} - ${
            activity.passingYearUG || "N/A"
          } - ${activity.subjectUG || "N/A"} - ${
            activity.percentageUG || "N/A"
          }`
        : ""
    }</td>
                 </tr>
               
                
               </tbody>
             </table>
           </div>
       
           <div style=${
             activity?.universityPG || activity?.passingYearPG
               ? "margin-top:2px"
               : "display:none"
           }>
             <h4 style="${sectionStyle}">Master's Details</h4>
             <table style="${tableStyle}"}>
               <tbody>
                 <tr>
                   <td style="${thTdStyle3}" >${
      activity?.universityPG || activity?.passingYearPG
        ? `${activity.universityPG || "N/A"} - ${
            activity.passingYearPG || "N/A"
          } - ${activity.subjectPG || "N/A"} - ${
            activity.percentagePG || "N/A"
          }`
        : ""
    }</td>
                   
                 </tr>
               
                
               </tbody>
             </table>
           </div>
       
           <div>
             <h4 style="${sectionStyle}">Preferences</h4>
             <table style="${tableStyle}"}>
               <tbody>
                 <tr  style=${
                   activity?.preferredDegree || activity?.preferredDegreeOther
                     ? "margin-top:0px"
                     : "display:none"
                 }>
                   <td style="${thTdStyle1}">Preferred Degree:</td>
                   <td style="${thTdStyle}">${
      activity.preferredDegree
        ? activity.preferredDegree
        : activity.preferredDegreeOther
        ? activity.preferredDegreeOther
        : ""
    }</td>
                 </tr>
                 <tr   style=${
                   Country?.length ? "margin-top:0px" : "display:none"
                 }>
                   <td style="${thTdStyle1}">Preferred Country:</td>
                   <td style="${thTdStyle}">${
      Country?.length ? Country?.join(",") : ""
    }</td>
                 </tr>
                 <tr style=${
                   activity.preferredField ? "margin-top:0px" : "display:none"
                 } >
                   <td style="${thTdStyle1}">Preferred Field of Study:</td>
                   <td style="${thTdStyle}">${
      activity?.preferredField || ""
    }</td>
                 </tr>
                 <tr  style=${
                   activity?.preferredIntake ? "margin-top:0px" : "display:none"
                 }>
                   <td style="${thTdStyle1}">Preferred Intake:</td>
                   <td style="${thTdStyle}">${
      activity?.preferredIntake || ""
    }</td>
                 </tr>
               </tbody>
             </table>
           </div>
       
           <div>
             <h4 style="${sectionStyle}">Additional Information</h4>
             <table style="${tableStyle}"}>
               <tbody>
                 <tr  style=${
                   activity.workExperience ? "margin-top:0px" : "display:none"
                 }>
                   <td style="${thTdStyle1}">Work Experience:</td>
                   <td style="${thTdStyle}">${
      activity?.workExperience || ""
    }</td>
                 </tr>
                 <tr  style=${
                   activity.givenTest ? "margin-top:0px" : "display:none"
                 }>
                   <td style="${thTdStyle1}">Given Test:</td>
                   <td style="${thTdStyle}">${activity?.givenTest || ""}</td>
                 </tr>
                 <tr  style=${
                   activity.testName ? "margin-top:0px" : "display:none"
                 }>
                   <td style="${thTdStyle1}">Test Name:</td>
                   <td style="${thTdStyle}">${activity.testName || ""}</td>
                 </tr>
                 <tr  style=${
                   heardFrom?.length ? "margin-top:0px" : "display:none"
                 }>
                   <td style="${thTdStyle1}">Heard From:</td>
                   <td style="${thTdStyle}">${
      heardFrom?.length ? heardFrom?.join(",") : ""
    }</td>
                 </tr>
                 <tr  style=${
                   activity.otherComments ? "margin-top:0px" : "display:none"
                 }>
                   <td style="${thTdStyle1}">Other Comments:</td>
                   <td style="${thTdStyle}">${activity.otherComments || ""}</td>
                 </tr>
               </tbody>
             </table>
           </div>

            <div id="personal_info" style="margin-top:1.1px">
                        <h4 style="${sectionStyle}">Recommended
            University</h4>
                        <table style="${tableStyle}">
                          <tbody>
                            <tr>
                              <td style="${thTdStyle2}">
                                Recommended Details: 
                              </td>
                              <td style="${thTdStyle2}">
                                <span style="${gridClr}">${
      Country2?.length ? Country2.map((item) => item.label).join(", ") : ""
    } </span>
                              </td>
                            </tr></tbody></table></div>

           <div id="personal_info" style="display:none;margin-top:1.2px">
             <h4 style="${sectionStyle}">Personal Details</h4>
             <table style="${tableStyle}">
               <tbody>
                 <tr>
                   <td style="${thTdStyle2}">
                     Branch: <span style="${clr}"> $$Branch</span>
                   </td>
                   <td style="${thTdStyle2}">
                     Event: <span style="${clr}">${eventId || ""} </span>
                   </td>
                 </tr>
                 <tr>
                   <td style="${thTdStyle2}">
                     Phone: <span style="${clr}">${
      details.Phone_No || ""
    } </span>
                   </td>
                   <td style="${thTdStyle2}">
                   
                     Email Address:<span style="${clr}">${
      details.Email_Address || ""
    } </span>
                   </td>
                 </tr>
       
                 <tr>
                   <td style="${thTdStyle2}">
                  
                     First Name:<span style="${clr}"> ${
      details?.First_Name || ""
    }</span>
                   </td>
                   <td style="${thTdStyle2}">
                     Last Name: <span style="${clr}">${
      details?.Last_Name || ""
    } </span>
                   </td> 
                   
                   <td style="${thTdStyle2}">
                     Full Name: <span style="${clr}">${
      details?.full_name || ""
    } </span>
                   </td> 
                 </tr>
                 
       
                 <tr>
                   <td style="${thTdStyle2}">
                     Phone No:<span style="${clr}">${
      details?.Gender?.toString() == "1"
        ? "Male"
        : details?.Gender?.toString() == "2"
        ? "Female"
        : "Other" || ""
    } </span>
                   </td>
                   <td style="${thTdStyle2}">
                  
                     Date of Birth: <span style="${clr}"> ${
      details?.Date_Of_Birth || ""
    }</span>
                   </td>
                 </tr>
       
                 <tr>
                   <td style="${thTdStyle2}">
                     Marital Status:
                     <span style="${clr}"> ${
      details?.Marital_Status === "1"
        ? "Unmarried"
        : details?.Marital_Status === "2"
        ? "Married"
        : "Other" || ""
    }</span>
                   </td>
                   <td style="${thTdStyle2}">
                     Alternate Phone:
                     <span style="${clr}"> ${details?.Phone_No1 || ""}</span>
                   </td>
                 </tr>
       
                 <tr>
                   <td style="${thTdStyle2}">
                     City:<span style="${clr}"> ${details?.City || ""}</span>
                   </td>
                   <td style="${thTdStyle2}">
                     State:<span style="${clr}"> ${details?.State || ""}</span>
                   </td>
                 </tr>
               </tbody>
             </table>
           </div>
       
         </div>
       </div>`;

    if (Country?.length == 0) {
      validator = `Error - Preferred Country  is required !`;
    }

    var dt;
    if (eventId === "") {
      dt = {
        ...details,
        ...activity,
        Activity: `Student Form Filled`,
        Activity_Des: activityHtml,
        recommendedCountry: [...Country2?.map((ev) => ev.value)],
        heardFrom: [...heardFrom],
        preferredCountry: [...Country],
        eventId,
      };
    } else {
      dt = {
        ...details,
        ...activity,
        Activity: `EventInteralCounsellorActivity${eventId}`,
        Activity_Des: activityHtml,
        recommendedCountry: [...Country2?.map((ev) => ev.value)],
        heardFrom: [...heardFrom],
        preferredCountry: [...Country],
        eventId,
      };

      //   Activity: `EventTaggedActivity${eventId}`,
    }
    if (validator === "success") {
      if (eventActivity) {
        dispatch(
          activityCreateDetails({
            ...dt,
            contactId: recid,
            link: window.location.href,
            eventUpdate: true,
          })
        );
      } else {
        dispatch(
          activityCreateDetails({
            ...dt,
            contactId: recid,
            link: window.location.href,
            eventUpdate: false,
          })
        );
      }
    } else {
      setFormError(validator);
    }
  };

  const save4thStep = (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    setSec2(false);
    setSec3(true);
    setSec4(false);
    setSec5(false);
    dispatch(contactDetails(recid));
    dispatch(activityDetails(recid, "EventInteralCounsellorActivity"));
  };

  const save5thStep = (e) => {
    e.preventDefault();
    window.location.reload();
  };

  useEffect(() => {
    if (successCreate || successAcc) {
      window.scrollTo(0, 0);
      setSec2(false);
      setSec3(false);
      setSec4(true);
      setSec5(false);
      setrecid(ContactId || ContactId3);
      dispatch(contactDetails(ContactId || ContactId3));
    }
  }, [dispatch, successCreate, successAcc]);

  useEffect(() => {
    if (successCreate2) {
      setDetails(contactJson);
      window.scrollTo(0, 0);
      setSec2(false);
      setSec3(false);
      setSec4(false);
      setSec5(true);
    }
  }, [dispatch, successCreate2]);

  useEffect(() => {
    if (contactDet) {
      setDetails({
        ...details,
        ...contactDet,
      });
    }
  }, [contactDet]);
  useEffect(() => {
    if (eventActivity) {
      let act = {};
      for (let key in eventActivity) {
        if (
          key == "recommendedCountry" ||
          key == "preferredCountry" ||
          key == "heardFrom"
        ) {
          if (eventActivity[key] == "null" || eventActivity[key] == null) {
            act[key] = [];
          } else {
            let mlt = eventActivity[key]?.split(",");

            act[key] = [...mlt];
            if (key == "recommendedCountry") {
              let jkl = [];
              for (let i = 0; i < mlt?.length; i++) {
                let objk = All_University_Logo.find((ev) => ev?.Id == mlt[i]);

                jkl.push({ label: objk?.Name, value: objk?.Id });
              }

              setCountry2([...jkl]);
            } else if (key == "preferredCountry") {
              setCountry([...mlt]);
            } else if (key == "heardFrom") {
              setHearForm([...mlt]);
            }
          }
        } else if (eventActivity[key] == "null" || eventActivity[key] == null) {
          act[key] = "";
        } else {
          act[key] = eventActivity[key];
        }
      }
      setActivity({ ...act });
    }
  }, [eventActivity]);

  return (
    <>
      <Header />
      <div className="custom-header">
        <div className="speaking-evaluation">
          <div className="speaking-evaluationOverlay"></div>
          <img
            src="../assets/img/speaking-banner.jpg"
            alt="speaking-banner"
            className="img-fluid"
          />
          <div className="container">
            <div className="speaking-evaluation_title">
              <h1>Registration Form</h1>
            </div>
          </div>
        </div>
      </div>

      {/* Main Body */}
      <section className="section-padding bg-f3f3f3">
        <div className="container">
          <div className="section-body">
            <div className="speaking-evaluation-body p-lg-5">
              <div className="seaking-evaluation-from">
                <div className="studentDashboard">
                  <div
                    className="my-application Registration-from"
                    id="myApplication"
                  >
                    <div className="row">
                      <div
                        className="col-md-12 "
                        style={{
                          marginTop:
                            window.innerWidth <= 480 ? "-20px" : "-50px",
                          textAlign: "right",
                        }}
                      >
                        {sec4 ? (
                          ""
                        ) : (
                          <button
                            onClick={handleClear}
                            className="btn btn-link"
                          >
                            Clear
                          </button>
                        )}
                      </div>

                      <div className="col-md-12">
                        <div className="custom-tab-details">
                          <div className="tab-content" id="v-pills-tabContent">
                            {/* Office Use Section */}
                            {/*sec1 ? (
                              <div className="tab-pane active">
                                <div className="officeUse mb-5 mt-3">
                                  <h2>For office use only</h2>
                                  <span className="CourseDescription-broder-btm  mb-4"></span>
                                  <div className="row">
                                    <div className="col-md-4">
                                      <div className="form-group">
                                        <label>Branch :</label>
                                        <select
                                          className=" form-control form-control-sm"
                                          name="Branch"
                                          id="Branch"
                                          value={details.Branch}
                                          onChange={handleChange}
                                        >
                                          <option value="">--Select--</option>
                                          <Branch />
                                        </select>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-group">
                                        <label>Medium :</label>
                                        <select
                                          className=" form-control form-control-sm"
                                          name="medium"
                                          id="medium"
                                          value={activity.medium}
                                          onChange={handleActivityChange}
                                        >
                                          <option>--Select--</option>
                                          <option value="Office">
                                            Office Visit
                                          </option>
                                          <option value="Call">Call</option>
                                          <option value="Event">Event</option>
                                        </select>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-group">
                                        <label>Event :</label>
                                        <select
                                          className=" form-control form-control-sm"
                                          name="eventId"
                                          id="eventId"
                                          value={activity.eventId}
                                          onChange={handleActivityChange}
                                        >
                                          <option value="">--Select--</option>
                                          <Event />
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )*/}

                            {/* Personal Information Section */}
                            {sec2 ? (
                              <div className="tab-pane active">
                                <div className="row">
                                  <div className="col-md-12">
                                    <h2>Personal Information</h2>
                                    <span className="CourseDescription-broder-btm"></span>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        Email Address<span>*</span>:
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        autoComplete="nope"
                                        placeholder="Email Address"
                                        name="Email_Address"
                                        required
                                        value={details.Email_Address}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        Mobile Number<span>*</span>:
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        autoComplete="nope"
                                        placeholder="Enter Number"
                                        name="Phone_No"
                                        required
                                        value={details.Phone_No}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        First Name<span>*</span>:
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="First Name"
                                        autoComplete="nope"
                                        required
                                        name="First_Name"
                                        value={details.First_Name}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        Last Name<span>*</span>:
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Last Name"
                                        autoComplete="nope"
                                        required
                                        name="Last_Name"
                                        value={details.Last_Name}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                  {/*                                   
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        Date of Birth<span></span>:
                                      </label>
                                      <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        autoComplete="nope"
                                        placeholder="DD/MM/YYYY"
                                        name="Date_Of_Birth"
                                        required
                                        value={
                                          details?.Date_Of_Birth
                                          // ? GET_DATE(details.Date_Of_Birth)
                                          // : ""
                                        }
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        Gender<span>*</span>:
                                      </label>
                                      <select
                                        className=" form-control form-control-sm"
                                        required
                                        name="Gender"
                                        value={details.Gender}
                                        onChange={handleChange}
                                      >
                                        <option value="">--Select--</option>
                                        <Gender />
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        Marital status<span>*</span>:
                                      </label>
                                      <select
                                        className=" form-control form-control-sm"
                                        name="Marital_Status"
                                        required
                                        value={details.Marital_Status}
                                        onChange={handleChange}
                                      >
                                        <option value="">--Select--</option>
                                        <MaritalStatus />
                                      </select>
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>Alternate Mobile Number:</label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        name="Phone_No1"
                                        autoComplete="nope"
                                        placeholder="Enter Alternate Number"
                                        value={details.Phone_No1}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        City<span>*</span>:
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        autoComplete="nope"
                                        placeholder="Enter City"
                                        name="City"
                                        required
                                        value={details.City}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        State<span>*</span>:
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        autoComplete="nope"
                                        placeholder="Enter State"
                                        name="State"
                                        value={details.State}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div> */}
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}

                            {/* Education Detail Section */}
                            {sec3 ? (
                              <>
                                <div className="new_f_C">
                                  <div class="form-container">
                                    <div className="hd_std">
                                      <h2>Education & Preferences Form</h2>
                                      <h5 style={{ color: "#f26524" }}>
                                        {details?.First_Name?.trim()
                                          ? `${details.First_Name} ${
                                              details.Last_Name
                                                ? details.Last_Name
                                                : ""
                                            }`
                                          : details?.full_name}{" "}
                                        {eventActivity ? "(P.C)" : ""}{" "}
                                      </h5>
                                    </div>
                                    <form>
                                      {/*  step 1 */}
                                      {step == 1 ? (
                                        <>
                                          <label className="head_t">
                                            12th Board Details
                                          </label>
                                          <div class="input-group">
                                            <input
                                              type="text"
                                              placeholder="Board"
                                              name="board"
                                              value={activity?.board}
                                              onChange={handleFormChange}
                                            />
                                            <input
                                              type="number"
                                              placeholder="Passing Year"
                                              name="passingYear12"
                                              value={activity?.passingYear12}
                                              onChange={handleFormChange}
                                            />
                                          </div>
                                          <div class="input-group">
                                            <input
                                              type="text"
                                              placeholder="Stream"
                                              name="stream"
                                              value={activity?.stream}
                                              onChange={handleFormChange}
                                            />
                                            <input
                                              type="number"
                                              placeholder="Percentage"
                                              name="percentage12"
                                              value={activity?.percentage12}
                                              onChange={handleFormChange}
                                            />
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* step 2 */}

                                      {step == 2 ? (
                                        <>
                                          <label className="head_t">
                                            Bachelor Details
                                          </label>
                                          <div class="input-group">
                                            <input
                                              type="text"
                                              placeholder="University"
                                              name="universityUG"
                                              value={activity?.universityUG}
                                              onChange={handleFormChange}
                                            />
                                            <input
                                              type="number"
                                              placeholder="Passing Year"
                                              name="passingYearUG"
                                              value={activity?.passingYearUG}
                                              onChange={handleFormChange}
                                            />
                                          </div>
                                          <div class="input-group">
                                            <input
                                              type="text"
                                              placeholder="Subject"
                                              name="subjectUG"
                                              value={activity?.subjectUG}
                                              onChange={handleFormChange}
                                            />
                                            <input
                                              type="text"
                                              placeholder="Percentage"
                                              name="percentageUG"
                                              value={activity?.percentageUG}
                                              onChange={handleFormChange}
                                            />
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* step 3 */}
                                      {step == 3 ? (
                                        <>
                                          {" "}
                                          <label className="head_t">
                                            Masters Details
                                          </label>
                                          <div class="input-group">
                                            <input
                                              type="text"
                                              placeholder="University"
                                              name="universityPG"
                                              value={activity?.universityPG}
                                              onChange={handleFormChange}
                                            />
                                            <input
                                              type="number"
                                              placeholder="Passing Year"
                                              name="passingYearPG"
                                              value={activity?.passingYearPG}
                                              onChange={handleFormChange}
                                            />
                                          </div>
                                          <div class="input-group">
                                            <input
                                              type="text"
                                              placeholder="Subject"
                                              name="subjectPG"
                                              value={activity?.subjectPG}
                                              onChange={handleFormChange}
                                            />
                                            <input
                                              type="text"
                                              placeholder="Percentage"
                                              name="percentagePG"
                                              value={activity?.percentagePG}
                                              onChange={handleFormChange}
                                            />
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* step 4 */}
                                      {step == 4 ? (
                                        <>
                                          {" "}
                                          <label className="head_t">
                                            Preferred Degree <b>*</b>
                                          </label>
                                          {/* <StudyLevel
                                                                    handleAchange={(vl) =>
                                                                      handleActivityChangep(vl)
                                                                    }
                                                                  /> */}
                                          <div class="radio-group prefd">
                                            <div>
                                              <input
                                                type="radio"
                                                name="degree"
                                                checked={
                                                  activity?.preferredDegree ==
                                                  "UG"
                                                }
                                                onChange={(e) => {
                                                  if (e.target.checked) {
                                                    setActivity({
                                                      ...activity,
                                                      preferredDegree: "UG",
                                                    });
                                                  }
                                                }}
                                                id="ug"
                                              />{" "}
                                              <label for="ug">UG</label>
                                            </div>
                                            <div>
                                              <input
                                                type="radio"
                                                name="degree"
                                                checked={
                                                  activity?.preferredDegree ==
                                                  "PG"
                                                }
                                                onChange={(e) => {
                                                  if (e.target.checked) {
                                                    setActivity({
                                                      ...activity,
                                                      preferredDegree: "PG",
                                                    });
                                                  }
                                                }}
                                                id="pg"
                                              />{" "}
                                              <label for="pg">PG</label>
                                            </div>
                                            <div>
                                              <input
                                                type="text"
                                                name="degree"
                                                placeholder="Other"
                                                value={
                                                  activity?.preferredDegreeOther
                                                }
                                                onChange={(e) =>
                                                  setActivity({
                                                    ...activity,
                                                    preferredDegreeOther:
                                                      e.target.value,
                                                  })
                                                }
                                                id="other"
                                              />{" "}
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}

                                      {/* Preferred Intake */}

                                      {step == 5 ? (
                                        <>
                                          {" "}
                                          <label className="head_t">
                                            Preferred Intake
                                          </label>
                                          <select
                                            name="preferredIntake"
                                            value={activity?.preferredIntake}
                                            onChange={handleFormChange}
                                          >
                                            <option value="">select</option>
                                            {/* <PreferredIntake /> */}
                                            {intakes ? (
                                              intakes.map((intak, i) => (
                                                <option
                                                  key={i + 11}
                                                  value={intak.Intake}
                                                >
                                                  {intak.Intake}
                                                </option>
                                              ))
                                            ) : (
                                              <>
                                                <option>Loading...</option>
                                              </>
                                            )}
                                          </select>
                                          <label className="head_t">
                                            Preferred Intake Year
                                          </label>
                                          <select
                                            name="preferredIntakeYear"
                                            value={
                                              activity?.preferredIntakeYear
                                            }
                                            onChange={handleFormChange}
                                          >
                                            <option value="">select</option>
                                            <Year />
                                          </select>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* step 5 */}
                                      {step == 6 ? (
                                        <>
                                          {" "}
                                          <label className="head_t">
                                            Preferred Country <b>*</b>
                                          </label>
                                          <div class="checkbox-group cntry">
                                            {CountryListJson?.map((ev, i) => (
                                              <div key={ev?.Id}>
                                                <input
                                                  type="checkbox"
                                                  checked={
                                                    Country.indexOf(
                                                      ev?.Country
                                                    ) == -1
                                                      ? false
                                                      : true
                                                  }
                                                  onChange={(e) => {
                                                    if (
                                                      e.target.checked == true
                                                    ) {
                                                      let c = [...Country];
                                                      c.push(ev?.Country);
                                                      setCountry([...c]);
                                                    } else {
                                                      let c = [...Country];
                                                      let index = c.indexOf(
                                                        ev?.Country
                                                      );
                                                      c.splice(index, 1);
                                                      setCountry([...c]);
                                                    }
                                                  }}
                                                />{" "}
                                                <span>{ev?.Country} </span>{" "}
                                              </div>
                                            ))}

                                            {/* <div>
                                                                    <input type="checkbox" />
                                                                    <span> UK</span>{" "}
                                                                  </div>
                                                                  <div>
                                                                    <input type="checkbox" />{" "}
                                                                    <span>USA </span>
                                                                  </div>
                                                                  <div>
                                                                    <input type="checkbox" />{" "}
                                                                    <span>Europe </span>{" "}
                                                                  </div>
                                                                  <div>
                                                                    {" "}
                                                                    <input type="checkbox" />{" "}
                                                                    <span>UAE </span>
                                                                  </div>
                                                                  <div>
                                                                    <input type="checkbox" />{" "}
                                                                    <span> Other</span>
                                                                  </div> */}
                                          </div>
                                          {Country.includes("OTHER") ? (
                                            <div>
                                              <input
                                                type="text"
                                                placeholder="Specify if Other"
                                                name="OtherCountry"
                                                value={activity?.OtherCountry}
                                                onChange={(e) => {
                                                  setActivity({
                                                    ...activity,
                                                    OtherCountry:
                                                      e.target.value,
                                                  });
                                                }}
                                              />
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* step 6 */}
                                      {step == 7 ? (
                                        <>
                                          {" "}
                                          <label className="head_t">
                                            Preferred Field of Study
                                          </label>
                                          <select
                                            name="preferredField"
                                            value={activity?.preferredField}
                                            onChange={handleFormChange}
                                          >
                                            <option value="">select</option>
                                            {/* <FieldOfStudy /> */}
                                            {fields ? (
                                              fields.map((field, i) => (
                                                <>
                                                  <option
                                                    key={i + 3}
                                                    value={field.Field_Of_Study}
                                                  >
                                                    {field.Field_Of_Study}
                                                  </option>
                                                </>
                                              ))
                                            ) : (
                                              <>
                                                <option>Loading...</option>
                                              </>
                                            )}
                                          </select>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* step 8 */}
                                      {step == 8 ? (
                                        <>
                                          {" "}
                                          <label className="head_t">
                                            Work Experience
                                          </label>
                                          <div class="radio-group  prefd">
                                            <div>
                                              <input
                                                type="radio"
                                                name="workExperience"
                                                id="yes"
                                                checked={
                                                  activity?.workExperience ==
                                                  "Yes"
                                                }
                                                onChange={() =>
                                                  setActivity({
                                                    ...activity,
                                                    workExperience: "Yes",
                                                  })
                                                }
                                              />
                                              <label for="yes">Yes</label>
                                            </div>
                                            <div>
                                              <input
                                                type="radio"
                                                id="no"
                                                name="workExperience"
                                                checked={
                                                  activity?.workExperience ==
                                                  "No"
                                                }
                                                onChange={() =>
                                                  setActivity({
                                                    ...activity,
                                                    workExperience: "No",
                                                  })
                                                }
                                              />
                                              <label for="no">No</label>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* step 9 */}
                                      {step == 9 ? (
                                        <>
                                          {" "}
                                          <label className="head_t">
                                            How did you hear about us? <b>*</b>
                                          </label>
                                          <div class="checkbox-group hear_about">
                                            {sourcesHeard?.map((ev, i) => (
                                              <div key={i + 679}>
                                                <input
                                                  type="checkbox"
                                                  checked={
                                                    heardFrom.indexOf(ev) == -1
                                                      ? false
                                                      : true
                                                  }
                                                  onChange={(e) => {
                                                    if (
                                                      e.target.checked == true
                                                    ) {
                                                      let c = [...heardFrom];
                                                      c.push(ev);
                                                      setHearForm([...c]);
                                                    } else {
                                                      let c = [...heardFrom];
                                                      let index = c.indexOf(ev);
                                                      c.splice(index, 1);
                                                      setHearForm([...c]);
                                                    }
                                                  }}
                                                />{" "}
                                                <span>{ev} </span>{" "}
                                              </div>
                                            ))}
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* <div class="checkbox-group"></div> */}
                                      {/* step 9 */}
                                      {step == 10 ? (
                                        <>
                                          {" "}
                                          <label className="head_t">
                                            Contact Type Important ?
                                          </label>
                                          <div class="radio-group  prefd">
                                            <div>
                                              <input
                                                type="radio"
                                                name="workExperience"
                                                id="yes"
                                                checked={
                                                  activity?.contact_Type ==
                                                  "Yes"
                                                }
                                                onChange={() =>
                                                  setActivity({
                                                    ...activity,
                                                    contact_Type: "Yes",
                                                  })
                                                }
                                              />
                                              <label for="yes">Yes</label>
                                            </div>
                                            <div>
                                              <input
                                                type="radio"
                                                id="no"
                                                name="workExperience"
                                                checked={
                                                  activity?.contact_Type == "No"
                                                }
                                                onChange={() =>
                                                  setActivity({
                                                    ...activity,
                                                    contact_Type: "No",
                                                  })
                                                }
                                              />
                                              <label for="no">No</label>
                                            </div>
                                          </div>
                                          <label className="head_t">
                                            Other Comments
                                          </label>
                                          <textarea
                                            rows="4"
                                            name={"otherComments"}
                                            value={activity?.otherComments}
                                            onChange={handleFormChange}
                                            placeholder="Enter your comments..."
                                          ></textarea>
                                        </>
                                      ) : (
                                        ""
                                      )}

                                      {/* {step == 11 ? (
                                        <>
                                          <label className="head_t">
                                            Recommended University <b>*</b>
                                          </label>
                                          <div class="checkbox-group cntry">
                                            {CountryListJson?.map((ev, i) => (
                                              <div key={ev?.Id}>
                                                {console.log(
                                                  Country2.indexOf(`${ev?.Id}`),
                                                  Country2
                                                )}
                                                <input
                                                  type="checkbox"
                                                  checked={
                                                    Country2.indexOf(
                                                      `${ev?.Id}`
                                                    ) == -1
                                                      ? false
                                                      : true
                                                  }
                                                  onChange={(e) => {
                                                    if (
                                                      e.target.checked == true
                                                    ) {
                                                      let c = [...Country2];
                                                      c.push(`${ev?.Id}`);
                                                      setCountry2([...c]);
                                                    } else {
                                                      let c = [...Country2];
                                                      let index = c.indexOf(
                                                        `${ev?.Id}`
                                                      );
                                                      c.splice(index, 1);
                                                      setCountry2([...c]);
                                                    }
                                                  }}
                                                />{" "}
                                                <span>{ev?.Country} </span>{" "}
                                              </div>
                                            ))}
                                          </div>{" "}
                                        </>
                                      ) : (
                                        ""
                                      )} */}

                                      {/* <button class="btn" type="submit">
                                                                  Submit
                                                                </button> */}
                                    </form>
                                  </div>
                                </div>
                                {step == 11 ? (
                                  <>
                                    <label className="head_t">
                                      Recommended University <b>*</b>
                                    </label>
                                    <div className="form-group fg">
                                      <MultiSelect
                                        options={
                                          All_University_Logo
                                            ? All_University_Logo?.map((el) => {
                                                return {
                                                  label: el.Name,
                                                  value: el.Id,
                                                };
                                              })
                                            : []
                                        }
                                        className="Multi_Selector"
                                        value={Country2}
                                        onChange={(e) => {
                                          setCountry2(e);
                                        }}
                                        labelledBy="Select"
                                      />
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          flexWrap: "wrap",
                                          gap: "15px",
                                          padding: "6px 0",
                                          alignItems: "center",
                                        }}
                                      >
                                        {Country2?.map((ev) =>
                                          All_University_Logo?.find(
                                            (eb) => eb.Id == ev?.value
                                          )?.Logo134x64 ? (
                                            <div>
                                              <img
                                                style={{ width: "80%" }}
                                                src={
                                                  All_University_Logo?.find(
                                                    (eb) => eb.Id == ev?.value
                                                  )?.Logo134x64
                                                }
                                              />
                                            </div>
                                          ) : All_University_Logo?.find(
                                              (eb) => eb.Id == ev?.value
                                            )?.Logo50x50 ? (
                                            <div>
                                              <img
                                                style={{ width: "70%" }}
                                                src={
                                                  All_University_Logo?.find(
                                                    (eb) => eb.Id == ev?.value
                                                  )?.Logo50x50
                                                }
                                              />
                                            </div>
                                          ) : All_University_Logo?.find(
                                              (eb) => eb.Id == ev?.value
                                            )?.Logo310x125 ? (
                                            <div>
                                              <img
                                                style={{ width: "60%" }}
                                                src={
                                                  All_University_Logo?.find(
                                                    (eb) => eb.Id == ev?.value
                                                  )?.Logo310x125
                                                }
                                              />
                                            </div>
                                          ) : (
                                            ev?.label
                                          )
                                        )}
                                      </div>
                                      {/* {All_University_Logo?.map((ev, i) => (
                                                                          <div key={ev?.Id}>
                                                                            {console.log(
                                                                              Country2.indexOf(`${ev?.Id}`),
                                                                              Country2
                                                                            )}
                                                                            <input
                                                                              type="checkbox"
                                                                              checked={
                                                                                Country2.indexOf(
                                                                                  `${ev?.Id}`
                                                                                ) == -1
                                                                                  ? false
                                                                                  : true
                                                                              }
                                                                              onChange={(e) => {
                                                                                if (
                                                                                  e.target.checked == true
                                                                                ) {
                                                                                  let c = [...Country2];
                                                                                  c.push(`${ev?.Id}`);
                                                                                  setCountry2([...c]);
                                                                                } else {
                                                                                  let c = [...Country2];
                                                                                  let index = c.indexOf(
                                                                                    `${ev?.Id}`
                                                                                  );
                                                                                  c.splice(index, 1);
                                                                                  setCountry2([...c]);
                                                                                }
                                                                              }}
                                                                            />{" "}
                                                                            <span>{ev?.Country} </span>{" "}
                                                                          </div>
                                                                        ))} */}
                                    </div>{" "}
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                            ) : (
                              <></>
                            )}

                            {sec4 ? (
                              <div className="tab-pane active">
                                <div className="row">
                                  <div className="col-md-12">
                                    <p>
                                      Thanks for the registration. Your
                                      Registration Id is:{" "}
                                      <strong style={{ fontSize: 30 }}>
                                        {ContactId}
                                      </strong>
                                    </p>
                                    <span className="CourseDescription-broder-btm  mb-4"></span>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}

                            {sec5 ? (
                              <div className="tab-pane active">
                                <div className="row">
                                  <div className="col-md-12">
                                    <p>
                                      Thanks for the registration. Your
                                      Registration Id is:{" "}
                                      <strong style={{ fontSize: 30 }}>
                                        {ContactId2}
                                      </strong>
                                    </p>
                                    <span className="CourseDescription-broder-btm  mb-4"></span>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>

                          <div className="row">
                            {FormError ? (
                              <p
                                style={{
                                  textAlign: "center",
                                  color: "red",
                                  margin: "0",
                                  padding: "0",
                                }}
                              >
                                {FormError}
                              </p>
                            ) : (
                              ""
                            )}
                            <div className="col-md-12 custom-form-btn mt-3 text-center">
                              {/* <p>Error :- All fields are compulsory</p> */}
                              {/*sec1 ? (
                                <button
                                  className="btn form-savebtn"
                                  id="showSucsess"
                                  onClick={(e) => save1stStep(e)}
                                >
                                  Save
                                </button>
                              ) : (
                                <></>
                              )*/}
                              {sec2 ? (
                                <>
                                  {/* <button
                                    className=" btn form-savebtn"
                                    id="showSucsess"
                                    onClick={(e) => save2ndStepPrev(e)}
                                  >
                                    Go Back
                                  </button> */}

                                  <span>&nbsp;</span>

                                  <button
                                    className=" btn form-savebtn"
                                    id="showSucsess"
                                    onClick={(e) => save2ndStep(e)}
                                  >
                                    {loadingCreate ? "Loading... " : "Submit"}
                                  </button>
                                  <p>{errorCreate}</p>
                                </>
                              ) : (
                                <></>
                              )}
                              {sec3 ? (
                                <>
                                  {loadingCreate || loadingAcu || loadingAcc ? (
                                    <div>Loading...</div>
                                  ) : (
                                    <>
                                      {/* <button
                                        type="button"
                                        className=" btn form-savebtn"
                                        id="showSucsess"
                                        onClick={(e) => save3rdStepPrev(e)}
                                      >
                                        Go Back
                                      </button> */}

                                      {/* <span>&nbsp;</span> */}

                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "20px",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <button
                                          type="button"
                                          disabled={loadingAcc}
                                          className="btn form-savebtn"
                                          id="showSucsess"
                                          onClick={(e) => {
                                            handleStepPrev();
                                          }}
                                        >
                                          {loadingCreate2 || loadingAcc
                                            ? "Loading..."
                                            : "Prev"}
                                        </button>{" "}
                                        <button
                                          type="button"
                                          className=" btn form-savebtn"
                                          disabled={loadingAcc}
                                          id="showSucsess"
                                          onClick={(e) => {
                                            step == 11
                                              ? save3rdStep(e)
                                              : handleStepNext();
                                          }}
                                        >
                                          {loadingCreate2 || loadingAcc
                                            ? "Loading..."
                                            : step == 11
                                            ? "Submit"
                                            : "Next"}
                                        </button>{" "}
                                      </div>

                                      <p>
                                        {errorCreate2 || errorAcu || errorAcc}
                                      </p>
                                    </>
                                  )}
                                </>
                              ) : (
                                <></>
                              )}
                              {sec4 ? (
                                <>
                                  {" "}
                                  {successAcc ? (
                                    <button
                                      className=" btn form-savebtn"
                                      id="showSucsess"
                                      onClick={(e) => save5thStep(e)}
                                    >
                                      New Registration
                                    </button>
                                  ) : (
                                    <button
                                      className=" btn form-savebtn"
                                      id="showSucsess"
                                      onClick={(e) => save4thStep(e)}
                                    >
                                      Continue to Educational Details
                                    </button>
                                  )}
                                </>
                              ) : (
                                <></>
                              )}

                              {sec5 ? (
                                <>
                                  <button
                                    className=" btn form-savebtn"
                                    id="showSucsess"
                                    onClick={(e) => save5thStep(e)}
                                  >
                                    New Registration
                                  </button>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </>
  );
}

export default BookMyShow;
